// This action is only used in step 2 (upsell products).
// It adds the addon product to all domains in the cart.

import {
  GET_PRODUCTS_REQUEST,
  GET_PRODUCTS_LOADED,
  GET_CART_REQUEST,
  GET_CART_SUCCESS,
  GET_CART_FAILURE,
} from "../../constants";
import { createAction, createErrorAction } from "../../utils";
import { getCartItems } from "../../selectors";
import showError from "../showError/showError";

// Cart
const getCartRequest = createAction(GET_CART_REQUEST);
const getCartSuccess = createAction(GET_CART_SUCCESS);
const getCartFailure = createErrorAction(GET_CART_FAILURE);
const setProductsLoading = createAction(GET_PRODUCTS_REQUEST);
const setProductsLoaded = createAction(GET_PRODUCTS_LOADED);

export const addAddonProductToDomains = (addonProductId) => {
  return async (dispatch, getState, { api }) => {
    // Load requests
    dispatch(getCartRequest());
    dispatch(setProductsLoading());

    const state = getState();
    const cartItems = getCartItems(state);
    const domainsInCart = cartItems.map((item) => item.fullDomain);

    let responseData = {
      getCart: false,
    };

    for (const domain of domainsInCart) {
      await api.addAddonProduct(addonProductId, domain).then(
        (data) => {},
        (err) => {
          dispatch(showError("default"));
          console.error("Add addonproducts failed", err);
        },
      );
    }

    // Get the updated cart
    await api.getCart().then(
      (data) => {
        responseData.getCart = data;
      },
      (err) => {
        console.error("Get cart failed", err);
        dispatch(showError("cartUpdateFailed"));
        dispatch(getCartFailure(err));
      },
    );

    if (responseData.getCart) {
      dispatch(getCartSuccess(responseData.getCart));
    }
    dispatch(setProductsLoaded());
  };
};
